import React from 'react';
import server from "../../server";
import {Link} from "react-router-dom";
import $ from 'jquery';
class SelectAreaModal extends React.Component{
    loadAreaButtons = () =>{
        const labels={"patient":"Paciente", "fisioterapist":"Fisioterapeuta", "doctor":"Médico", "secretary":"Secretária"}

        return this.props.areas.map((area) =>{
            return <Link onClick={() =>{server.userType = area; this.props.logged()}} to="/sistema" style={{marginBottom: "30px"}} className="btn btn-quartenary fsz-md bdr-full  pX-30 pY-10">{labels[area]}</Link>
        })
    }

    render(){
        return(
            <div style={(this.props.active ? {} : {display:"none"})}>
                <div className="overlay" style={{position:"fixed", top:0, left:0, width:"100%", height:"100%", backgroundColor:"rgba(0,0,0,0.6)", zIndex: 1000}}></div>
                <div className="areas" style={{display: "flex", flexDirection:"column", padding: "50px", width: "400px", backgroundColor: "white", zIndex: 1001, height: "600px", position: "fixed", top: 0, left: 0, right: 0, bottom: 0, borderRadius: "5px", margin: "auto"}}>
                    <h2 style={{margin: "0px 0px 50px 0px"}} className="ta-c c-client-default">Escolha o Módulo</h2>
                    {this.loadAreaButtons()}
                </div>
            </div>
        )
    }
}


export class Header extends React.Component{

    state = {
        a: 0
    }

    getClass = (page) =>{
        return (window.location.pathname == page ? "selected-page" : "");
    }

    componentDidMount(){
        $(".link").click(function(){
            $("body").toggleClass("stop-scrolling")
            $(".mobile-menu").toggleClass("opened");
            $(".mobile-menu").toggleClass("closed");
        })
    }

    render(){
        return(
            <div class="header navbar bdrs-0">
                <SelectAreaModal logged={this.props.logged} active={this.props.active} areas={this.props.areas}/>
                <div class="header-container">
                <section class="blues-content">
                    <div class="top-menu-content">
                    <ul class="nav-left">
                        <li>
                        <a href="/#/" id='sidebar-toggle' class="sidebar-toggle logo-white" href="javascript:void(0);">

                        </a>
                        </li>
                        <ul class="nav-left d-n@md-">
                            <li class="mR-20 ">
                                <Link onClick={() => this.setState({a: this.state.a + 1})} to="/home" id="patient-link" className={this.getClass("/home")}>
                                    <b>Paciente</b>
                                </Link>
                            </li>
                            <li id="doctor-banner-link" className={"mR-20 " + this.getClass("/home/medico")}>
                                <Link onClick={() => this.setState({a: this.state.a + 1})} to="/home/medico">
                                    <b>Médico</b>
                                </Link>
                            </li>
                            <li class="mR-20 ">
                                <a id="contact-form-link">
                                <b>Contato</b>
                                </a>
                            </li>
                        </ul>
                    </ul>



                    <ul class="nav-right top-nav form-top">
                        <div>
                        <div class="peers">
                            <div class="top-login-form mR-5 d-n@md-">
                            <label>CPF</label>
                            <input id="cpf" onChange={this.props.changeState} value={this.props.cpf} type="text" />
                            </div>
                            <div class="top-login-form d-n@md-">
                            <label>Senha</label>
                            <input id="password" onChange={this.props.changeState} value={this.props.password} type="password" />
                            </div>
                            <div>
                            <button onClick={this.props.login} type="button" class="btn btn-quartenary mL-5 login-btn d-n@md-">
                                <i class="material-icons fsz-md">
                                arrow_forward
                                </i>
                            </button>
                            </div>

                        </div>
                        <div class="ta-e d-n@md-">
                            <span class="forget-pass-top">
                            <label class="ta-r"> Esqueci minha senha</label>

                            </span>

                        </div>
                        </div>


                        <li class="d-n@md+ mobile-button-menu">
                        <a class="no-after">
                            <i class="fa fa-bars"></i>
                        </a>
                        </li>
                    </ul>
                    </div>
                </section>
                </div>

                <div style={{top:0, height: "100vh"}} class="mobile-menu none closed">
                    <div class="mobile-menu-inner bgc-client-default">
                    <div>
                        <ul>
                        <li><Link className="link" style={{color:"#fafafa"}} to="/home">Paciente</Link></li>
                        <li><Link className="link" style={{color:"#fafafa"}} to="/home/medico">Médico</Link></li>
                        <li class="mobile-link">
                            <button type="button" class="btn btn-outline-secondary fsz-md bdr-full  mT-30 pX-30 pY-10 big-button-text">
                            <b>Entrar no sistema</b>
                            </button>
                        </li>
                        </ul>
                        <div class="">

                        </div>

                    </div>

                    </div>
                </div>

            </div>
        )
    }
}


// WEBPACK FOOTER //
// ./src/pages/home/Header.js